import React, { useEffect, useState } from "react";
import "./style.css";
import { message } from "antd";
import { getIdle } from "../../../API/idle";
import Lottie from "lottie-react";
import reportGeneration from "../../../Assets/Animations/Report Generation.json";
import { useDateFilter } from "../../../Contexts/DateFilterContext";
import LineChart from "../../../Components/Charts/LineChart";
import BarChart from "../../../Components/Charts/BarChart";
import GenericTable from "../../../Components/GenericTable";

const Idle = () => {
  const defaultIdleData = {
    idle_fuel_cost: {},
    idle_fuel_loss: [],
    fleet_idle: {},
    vehicle_idle: {},
    co_emission: {},
    idle_vehicles: [],
    idlevsmovementvsengineoff: {},
    fleet_idle_fuel_cost: 0,
    fleet_idle_fuel_loss: 0,
    idle_percentage: 0,
    movement_percentage: 0,
    engineoff_percentage: 0,
  };
  const [idleData, setIdleData] = useState(defaultIdleData);
  const [loading, setLoading] = useState(true);
  const { from, to } = useDateFilter();

  useEffect(() => {
    if (!to || !from) {
      return;
    }

    const fetchFuelData = async () => {
      try {
        setLoading(true);
        const response = await getIdle(to, from);
        setIdleData(response.data);
        setLoading("false");
      } catch (error) {
        message.error("Failed to fetch fuel data");
        console.log(error, "Failed to fetch fuel data");
      }
      setLoading(false);
    };

    fetchFuelData();
  }, [to, from]);

  const idleFuelLossColumns = [
    {
      title: <span className="vehicle-title">Vehicle Name</span>,
      dataIndex: "vehicle_name",
      key: "vehicle_name",
      sorter: (a, b) =>
        a.vehicle_name.localeCompare(b.vehicle_name, undefined, {
          numeric: true,
        }),
    },
    {
      title: "Idle Time",
      dataIndex: "time",
      key: "time",
      sorter: (a, b) =>
        a.time.localeCompare(b.time, undefined, {
          numeric: true,
        }),
    },
    {
      title: "Idle Fuel Usage",
      dataIndex: "usage",
      key: "usage",
      sorter: (a, b) => a.usage - b.usage,
    },
    {
      title: "Idle Cost $",
      dataIndex: "idle_cost",
      key: "idle_cost",
      sorter: (a, b) => a.usage - b.usage,
    },
  ];

  return (
    <div className="idle">
      {loading ? (
        <div
          style={{
            width: "100%",
            height: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
          className="loader-container"
        >
          <Lottie
            animationData={reportGeneration}
            loop={true}
            style={{ width: 150, height: 150 }}
          />
        </div>
      ) : (
        <div className="rows-container">
          <div className="row tabs">
            <div className="tab-item">
              <div className="left">
                <span className="tab-title">Fleet Idle Fuel Cost</span>
                <span className="value-box" style={{ color: "#DFB400" }}>
                  $ {idleData?.fleet_idle_fuel_cost}
                </span>
              </div>
            </div>

            <div className="tab-item">
              <div className="left">
                <span className="tab-title">Fleet Idle Fuel Loss</span>
                <span className="value-box" style={{ color: "#FB3748" }}>
                  {idleData?.fleet_idle_fuel_loss} L
                </span>
              </div>
            </div>

            <div className="tab-item">
              <div className="left">
                <span className="tab-title">
                  Fleet Idle vs Movement vs Engine Off
                </span>

                <div className="value-legend-grid">
                  <div className="value-legend-col">
                    <span
                      className="value-box value-box1"
                      style={{ color: "#155DFC" }}
                    >
                      {idleData?.idle_percentage} %
                    </span>
                    <span className="legend-item">
                      <span
                        className="legend-color"
                        style={{ background: "#155DFC" }}
                      ></span>
                      Idle
                    </span>
                  </div>

                  <div className="value-legend-col">
                    <span
                      className="value-box value-box2"
                      style={{ color: "#1FC16B" }}
                    >
                      {idleData?.movement_percentage} %
                    </span>
                    <span className="legend-item">
                      <span
                        className="legend-color"
                        style={{ background: "#1FC16B" }}
                      ></span>
                      Movement
                    </span>
                  </div>

                  <div className="value-legend-col">
                    <span
                      className="value-box value-box3"
                      style={{ color: "#FB3748" }}
                    >
                      {idleData?.engineoff_percentage} %
                    </span>
                    <span className="legend-item">
                      <span
                        className="legend-color"
                        style={{ background: "#FB3748" }}
                      ></span>
                      Engine Off
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="graph">
              <LineChart
                graphData={idleData?.idle_fuel_cost || {}}
                lengthKeys={1}
                colourTheme={["#FB3748"]}
                graphTitle="Idle Fuel Cost"
                selectTenByDefault={false}
                units={["$"]}
                classNameCSS="fuel-cost"
              />
            </div>
            <div className="graph">
              <LineChart
                graphData={idleData?.co_emission || {}}
                lengthKeys={1}
                colourTheme={["#FB3748"]}
                graphTitle="CO2 Emissions"
                selectTenByDefault={false}
                units={["Tonne"]}
                classNameCSS="c02-emission"
              />
            </div>
          </div>
          <div className="row">
            <div className="graph">
              <LineChart
                graphData={idleData?.fleet_idle || {}}
                lengthKeys={1}
                colourTheme={["#1FC16B"]}
                graphTitle="Fleet Idle (%)"
                selectTenByDefault={false}
                units={["%"]}
                classNameCSS="fleet-idle"
              />
            </div>
            <div className="graph">
              <BarChart
                graphData={idleData?.vehicle_idle || {}}
                lengthKeys={1}
                colourTheme={["#1FC16B"]}
                graphTitle="Vehicle Idle (%)"
                selectTenByDefault={false}
                units={["%"]}
                classNameCSS="vehicle-data"
              />
            </div>
          </div>
          <div className="row">
            <div className="graph">
              <GenericTable
                title="Idle Fuel Loss"
                dataSource={idleData?.idle_fuel_loss}
                columns={idleFuelLossColumns}
              />
            </div>
          </div>

          <div className="graph">
            <LineChart
              graphData={idleData?.idlevsmovementvsengineoff || {}}
              lengthKeys={3}
              colourTheme={["#1FC16B", "#FB3748", "#2662D9"]}
              graphTitle="Idle vs Movement vs Engine Off"
              selectTenByDefault={true}
              units={["%", "%", "%"]}
              classNameCSS="idle-vs-movement"
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default Idle;
